import request from '@/utils/request'
import URL from './urlTranslator'

// 邮件发送
export function fileHistorySendEmailService(data) {
  return request({
    url: URL.seaExport.sendEmail,
    method: 'post',
    data
  })
}

// 通过指令发送邮件
export function sendEmailByInstruction(data) {
  return request({
    url: URL.seaExport.sendEmailByInstruction,
    method: 'post',
    data
  })
}

// 邀请对单邮件发送
export function sendHblCargoDocEmail(data) {
  return request({
    url: URL.seaExport.sendHblCargoDocEmail,
    method: 'post',
    data
  })
}

// 邮件内容获取
export function getSetMailTemplate(data) {
  return request({
    url: URL.seaExport.getSetMailTemplate,
    method: 'post',
    data
  })
}

// 获取模板并组装数据项（带附件）
export function getSetMailTemplateWithAttach(data) {
  return request({
    url: URL.seaExport.getSetMailTemplateWithAttach,
    method: 'post',
    data
  })
}

// 获取模板并组装数据项（带附件）(批量 非主小票)
export function getSetMailTemplateWithAttachMulti(data) {
  return request({
    url: URL.seaExport.getSetMailTemplateWithAttachMulti,
    method: 'post',
    data
  })
}

// V3发送邮件
export function sendMail(data) {
  return request({
    url: URL.sys.sendMail,
    method: 'post',
    data
  })
}
